import React, { useState, useEffect } from "react";
import "./Work.css";
import { Container, ListGroup } from "react-bootstrap";
import logi from "../../../Asset/workWith/industries-logistic.svg";
import health from "../../../Asset/workWith/industries-healthcare.svg";
import entertain from "../../../Asset/workWith/industries-entertainment.svg";
import fintech from "../../../Asset/workWith/industries-fintech.svg";
import hrms from "../../../Asset/workWith/industries-hrms.svg";
import ecom from "../../../Asset/workWith/industries-ecommerce.svg";
import logo1 from "../../../Asset/workWith/industry-logo-1.png";
import logo2 from "../../../Asset/workWith/industry-logo-2.png";
import logo3 from "../../../Asset/workWith/industry-logo-3.png";
import logo4 from "../../../Asset/workWith/industry-logo-4.png";
import logo5 from "../../../Asset/workWith/industry-logo-5.png";
import logo6 from "../../../Asset/workWith/industry-logo-6.png";
import indusLink from "../../../Asset/workWith/industry-link.png";
import java from "../../../Asset/workWith/Java.png";
import java1 from "../../../Asset/workWith/industry-badge-1.png";
import node from "../../../Asset/workWith/industry-badge-2.png";
import mySql from "../../../Asset/workWith/industry-badge-3.png";
import bootstrap from "../../../Asset/workWith/industry-badge-4.png";
import react from "../../../Asset/workWith/industry-badge-5.png";
import sixth from "../../../Asset/workWith/industry-badge-6.png";
import indusImg1 from "../../../Asset/workWith/industry-1.webp";
import indusImg2 from "../../../Asset/workWith/industry-2.webp";
import indusImg3 from "../../../Asset/workWith/industry-3.webp";
import indusImg4 from "../../../Asset/workWith/industry-4.webp";
import indusImg5 from "../../../Asset/workWith/industry-5.webp";
import indusImg6 from "../../../Asset/workWith/industry-6.webp";
import { useNavigate } from "react-router-dom";

const Workwith = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/portfolio");
  };

  const industries = [
    { id: 0, name: "Logistics", image: logi },
    { id: 1, name: "Healthcare", image: health },
    { id: 2, name: "Entertainment", image: entertain },
    { id: 3, name: "Fintech", image: fintech },
    { id: 4, name: "HRMS", image: hrms },
    { id: 5, name: "E-commerce", image: ecom },
  ];
  const defaultActiveTab = 0;
  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTab((prevActiveTab) => {
        if (prevActiveTab < industries.length - 1) {
          return prevActiveTab + 1;
        } else {
          clearInterval(interval);
          return prevActiveTab;
        }
      });
    }, 5000);
    return () => clearInterval(interval);
  });

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const tabContents = [
    <div className="first-tabContent">
      <div className="indus-content">
        <img className="indus-logo" src={logo1} alt="ShipTime"></img>
        <p className="indus-pTeg">
          Partnership with<strong className="ms-2 me-1">ShipTime</strong>
          <img src={indusLink} alt="link" />
          WebOsmitic
        </p>
        <div className="indus-badge">
          <img src={java1} alt="Java"></img>
          <img src={node} alt="Node"></img>
          <img src={mySql} alt="MySQL"></img>
          <img src={bootstrap} alt="Bootstrap"></img>
        </div>
        <div className="indus-detail d-flex">
          <div className="indus-detail-img">
            <img src={indusImg1} alt="Shipping Simplified"></img>
          </div>
          <div className="indus-detail-text">
            <h4 className="mb-3">Shipping Simplified</h4>
            <p>
              ShipTime is a convenient shipping solution. Manage orders from
              multiple platforms like Shopify and WooCommerce. Save up to 65%
              with reputable carriers like Canada Post, UPS, and FedEx.
            </p>
            <span onClick={handleClick}>
              Learn More
              <svg
                width="25"
                height="20"
                viewBox="0 0 14 8"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                className="ms-3"
              >
                <path d="M0.636364 4.45454H11.8273L9.73182 6.55004C9.4833 6.79852 9.4833 7.20146 9.73182 7.44998C9.85609 7.5742 10.019 7.63635 10.1818 7.63635C10.3447 7.63635 10.5076 7.5742 10.6318 7.44994L13.8136 4.26812C14.0621 4.01964 14.0621 3.6167 13.8136 3.36818L10.6318 0.186359C10.3833 -0.0621197 9.98035 -0.0621197 9.73182 0.186359C9.4833 0.434838 9.4833 0.837784 9.73182 1.0863L11.8273 3.18181H0.636364C0.284921 3.18181 0 3.46673 0 3.81817C0 4.16961 0.284921 4.45454 0.636364 4.45454Z" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>,
    <div className="second-tabContent">
      <div className="indus-content">
        <img className="indus-logo" src={logo2} alt="Welnes"></img>
        <div className="indus-badge">
          <img src={react} alt="React"></img>
          <img src={node} alt="Node"></img>
          <img src={mySql} alt="MySQL"></img>
          <img src={bootstrap} alt="Bootstrap"></img>
        </div>
        <div className="indus-detail d-flex">
          <div className="indus-detail-img">
            <img src={indusImg2} alt="Personalized Home Fitness"></img>
          </div>
          <div className="indus-detail-text">
            <h4 className="mb-3">Personalized Home Fitness </h4>
            <p>
              Customized home workouts and diets by Welnes. Get professional
              guidance, stay motivated, and achieve noticeable results in record
              time.
            </p>
            <span onClick={handleClick}>
              Learn More
              <svg
                width="25"
                height="20"
                viewBox="0 0 14 8"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                className="ms-3"
              >
                <path d="M0.636364 4.45454H11.8273L9.73182 6.55004C9.4833 6.79852 9.4833 7.20146 9.73182 7.44998C9.85609 7.5742 10.019 7.63635 10.1818 7.63635C10.3447 7.63635 10.5076 7.5742 10.6318 7.44994L13.8136 4.26812C14.0621 4.01964 14.0621 3.6167 13.8136 3.36818L10.6318 0.186359C10.3833 -0.0621197 9.98035 -0.0621197 9.73182 0.186359C9.4833 0.434838 9.4833 0.837784 9.73182 1.0863L11.8273 3.18181H0.636364C0.284921 3.18181 0 3.46673 0 3.81817C0 4.16961 0.284921 4.45454 0.636364 4.45454Z" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>,
    <div className="third-tabContent">
      <div className="indus-content">
        <img className="indus-logo" src={logo3} alt="Replay Poker"></img>
        <div className="indus-badge">
          <img src={bootstrap} alt="Bootstrap"></img>
          <img src={java} alt="React"></img>
        </div>
        <div className="indus-detail d-flex">
          <div className="indus-detail-img">
            <img src={indusImg3} alt="Gaming"></img>
          </div>
          <div className="indus-detail-text">
            <h4 className="mb-3">Gaming</h4>
            <p>
              Play free poker online. No download required! Replay Poker is one
              of the most authentic free online poker sites. Replay Poker is a
              great place to play poker for fun with others in a friendly
              atmosphere.
            </p>
            <span onClick={handleClick}>
              Learn More
              <svg
                width="25"
                height="20"
                viewBox="0 0 14 8"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                className="ms-3"
              >
                <path d="M0.636364 4.45454H11.8273L9.73182 6.55004C9.4833 6.79852 9.4833 7.20146 9.73182 7.44998C9.85609 7.5742 10.019 7.63635 10.1818 7.63635C10.3447 7.63635 10.5076 7.5742 10.6318 7.44994L13.8136 4.26812C14.0621 4.01964 14.0621 3.6167 13.8136 3.36818L10.6318 0.186359C10.3833 -0.0621197 9.98035 -0.0621197 9.73182 0.186359C9.4833 0.434838 9.4833 0.837784 9.73182 1.0863L11.8273 3.18181H0.636364C0.284921 3.18181 0 3.46673 0 3.81817C0 4.16961 0.284921 4.45454 0.636364 4.45454Z" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>,
    <div className="fourth-tabContent">
      <div className="indus-content">
        <img className="indus-logo" src={logo4} alt="Bank of Montreal"></img>
        <div className="indus-badge">
          <img src={react} alt="React"></img>
          <img src={java1} alt="Node"></img>
          <img src={sixth} alt="MySQL"></img>
          <img src={bootstrap} alt="Bootstrap"></img>
        </div>
        <div className="indus-detail d-flex">
          <div className="indus-detail-img">
            <img src={indusImg4} alt="Fintech"></img>
          </div>
          <div className="indus-detail-text">
            <h4 className="mb-3">Fintech</h4>
            <p>
              Leading the way in banking and finance with innovative fintech
              solutions. The Bank of Montreal offers a wide range of financial
              services to meet the needs of both individuals and businesses.
            </p>
            <span onClick={handleClick}>
              Learn More
              <svg
                width="25"
                height="20"
                viewBox="0 0 14 8"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                className="ms-3"
              >
                <path d="M0.636364 4.45454H11.8273L9.73182 6.55004C9.4833 6.79852 9.4833 7.20146 9.73182 7.44998C9.85609 7.5742 10.019 7.63635 10.1818 7.63635C10.3447 7.63635 10.5076 7.5742 10.6318 7.44994L13.8136 4.26812C14.0621 4.01964 14.0621 3.6167 13.8136 3.36818L10.6318 0.186359C10.3833 -0.0621197 9.98035 -0.0621197 9.73182 0.186359C9.4833 0.434838 9.4833 0.837784 9.73182 1.0863L11.8273 3.18181H0.636364C0.284921 3.18181 0 3.46673 0 3.81817C0 4.16961 0.284921 4.45454 0.636364 4.45454Z" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>,
    <div className="fifth-tabContent">
      <div className="indus-content">
        <img className="indus-logo" src={logo5} alt="HRTech"></img>
        <div className="indus-badge">
          <img src={react} alt="React"></img>
          <img src={node} alt="Node"></img>
        </div>
        <div className="indus-detail d-flex">
          <div className="indus-detail-img">
            <img src={indusImg5} alt="HRMS"></img>
          </div>
          <div className="indus-detail-text">
            <h4 className="mb-3">HRMS</h4>
            <p>
              Streamline your HR processes with our cutting-edge HRMS solutions.
              Manage employee data, track attendance, and more with ease.
            </p>
            <span onClick={handleClick}>
              Learn More
              <svg
                width="25"
                height="20"
                viewBox="0 0 14 8"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                className="ms-3"
              >
                <path d="M0.636364 4.45454H11.8273L9.73182 6.55004C9.4833 6.79852 9.4833 7.20146 9.73182 7.44998C9.85609 7.5742 10.019 7.63635 10.1818 7.63635C10.3447 7.63635 10.5076 7.5742 10.6318 7.44994L13.8136 4.26812C14.0621 4.01964 14.0621 3.6167 13.8136 3.36818L10.6318 0.186359C10.3833 -0.0621197 9.98035 -0.0621197 9.73182 0.186359C9.4833 0.434838 9.4833 0.837784 9.73182 1.0863L11.8273 3.18181H0.636364C0.284921 3.18181 0 3.46673 0 3.81817C0 4.16961 0.284921 4.45454 0.636364 4.45454Z" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>,
    <div className="sixth-tabContent">
      <div className="indus-content">
        <img className="indus-logo" src={logo6} alt="Ecommerce"></img>
        <div className="indus-badge">
          <img src={react} alt="React"></img>
          <img src={mySql} alt="MySQL"></img>
          <img src={sixth} alt="Node"></img>
        </div>
        <div className="indus-detail d-flex">
          <div className="indus-detail-img">
            <img src={indusImg6} alt="Ecommerce"></img>
          </div>
          <div className="indus-detail-text">
            <h4 className="mb-3">E-commerce</h4>
            <p>
              Elevate your online shopping experience with our state-of-the-art
              e-commerce platform. We provide robust solutions to help you
              manage your online store efficiently.
            </p>
            <span onClick={handleClick}>
              Learn More
              <svg
                width="25"
                height="20"
                viewBox="0 0 14 8"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
                className="ms-3"
              >
                <path d="M0.636364 4.45454H11.8273L9.73182 6.55004C9.4833 6.79852 9.4833 7.20146 9.73182 7.44998C9.85609 7.5742 10.019 7.63635 10.1818 7.63635C10.3447 7.63635 10.5076 7.5742 10.6318 7.44994L13.8136 4.26812C14.0621 4.01964 14.0621 3.6167 13.8136 3.36818L10.6318 0.186359C10.3833 -0.0621197 9.98035 -0.0621197 9.73182 0.186359C9.4833 0.434838 9.4833 0.837784 9.73182 1.0863L11.8273 3.18181H0.636364C0.284921 3.18181 0 3.46673 0 3.81817C0 4.16961 0.284921 4.45454 0.636364 4.45454Z" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>,
  ];
  return (
    <>
      <section className="workWith-section">
        <Container>
          <div className="top-text-workWith">
            <h2>
              INDUSTRIES <span>WE WORK WITH</span>
            </h2>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-4 col-xl-4 indus-left">
              {industries.map((industry) => (
                <div
                  key={industry.id}
                  onClick={() => handleTabClick(industry.id)}
                  className={`industry-item ${
                    activeTab === industry.id ? "active" : ""
                  }`}
                >
                  <img src={industry.image} alt={industry.name} />
                  <h5>{industry.name}</h5>
                </div>
              ))}
              <div className="indus-left-btn mb-3" onClick={handleClick}>
                <button>View Portfolio</button>
              </div>
            </div>
            <div className="col-lg-8 col-xl-8">
              <div
                className="sidebar_one"
                style={{
                  position: "fixed",
                }}
              >
                <ListGroup>
                  {[
                    "Logistics",
                    "Healthcare",
                    "Entertainment",
                    "Fintech",
                    "HRMS",
                    "E-commerce",
                  ].map((tab, index) => (
                    <ListGroup.Item key={index}>{tab}</ListGroup.Item>
                  ))}
                </ListGroup>
              </div>
              <div className="content_main">{tabContents[activeTab]}</div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Workwith;
